import { render, staticRenderFns } from "./StatInspItemQuoteSummary.vue?vue&type=template&id=131da125"
import script from "./StatInspItemQuoteSummary.vue?vue&type=script&lang=js"
export * from "./StatInspItemQuoteSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports